import React from 'react';
import { Card, CardContent, Typography, Box, Alert, Link } from '@mui/material';

const Uploader: React.FC = () => {
  const url = 'https://apps.firstshield.in/uploader/';

  return (
    <Card>
      <CardContent>
        <Typography variant="h4" gutterBottom color="primary">
          Uploader
        </Typography>
        <Alert severity="info" sx={{ mb: 2 }}>
          If the embedded app does not load, open it directly: <Link href={url} target="_blank" rel="noopener noreferrer">Open Uploader</Link>
        </Alert>
        <Box sx={{ height: '80vh', border: '1px solid #e0e0e0', borderRadius: 1, overflow: 'hidden' }}>
          <iframe
            title="Streamlit Uploader"
            src={url}
            style={{ width: '100%', height: '100%', border: 'none' }}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default Uploader;


